(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("borderless-dark-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["borderless-dark-panelless"] = factory();
	else
		root["SurveyTheme"] = factory();
})(this, function() {
return 